import { createSlice } from "@reduxjs/toolkit";
import { getAgencyList } from "./thunk";

export interface IState {
  lstAgency: any;
  isAgencyLoading: boolean;
  isAgencySuccess: boolean;

  error: any;
}

export const initialState: IState = {
  lstAgency: null,
  isAgencyLoading: false,
  isAgencySuccess: false,

  error: {},
};

const AgencySlice = createSlice({
  name: "Agency",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Advertisements
    builder.addCase(getAgencyList.pending, (state: IState, action: any) => {
      state.isAgencyLoading = true;
    });
    builder.addCase(
      getAgencyList.fulfilled,
      (state: IState, action: any) => {
        state.lstAgency = action.payload.data;
        state.isAgencySuccess = true;
        state.isAgencyLoading = false;
      }
    );
    builder.addCase(
      getAgencyList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isAgencySuccess = false;
        state.isAgencyLoading = false;
      }
    );
  },
});

export default AgencySlice.reducer;